import { AxiosResponse } from "axios";

import {
  IAddStudyRequest,
  IStudy,
  IUpdateStudyRequest,
} from "../../@types/admin/AdminStudy";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

/**
 * Studies (signup codes) admin page (EN-5155), migrated from the Retool
 * Studies app. The list endpoint takes optional filters and pagination; both
 * are omitted so the whole catalogue comes back for client-side search, as
 * Retool's table did.
 */
export const studiesService = {
  async getStudies(): Promise<AxiosResponse<IPaginatedResponse<IStudy[]>>> {
    return api.get<IPaginatedResponse<IStudy[]>>("/Retool/Studies");
  },

  async addStudy(request: IAddStudyRequest): Promise<AxiosResponse<IStudy>> {
    return api.post<IStudy>("/Retool/Studies", request);
  },

  async updateStudy(
    request: IUpdateStudyRequest
  ): Promise<AxiosResponse<IStudy>> {
    return api.put<IStudy>(`/Retool/Studies/${request.id}`, request);
  },
};
